import React from 'react';
import { Typography } from '@mui/material';

const PageTitle = ({ children, sx }) => {
    return (
        <Typography
            variant="h3"
            sx={{
                mt: 1,
                mb: 3.5,
                px: 2,
                textAlign: 'center',
                ...sx,
            }}
        >
            {children}
        </Typography>
    );
};

export { PageTitle };
